var _path, _g, _path2, _g2, _circle, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8266 45.9133C66.8266 61.8817 53.8817 74.8266 37.9133 74.8266C21.9449 74.8266 9 61.8817 9 45.9133C9 29.9449 21.9449 17 37.9133 17C53.8817 17 66.8266 29.9449 66.8266 45.9133ZM28.0403 40.2711C28.0403 45.7237 32.4605 50.144 37.9131 50.144C43.3657 50.144 47.786 45.7237 47.786 40.2711C47.786 34.8185 43.3657 30.3983 37.9131 30.3983C32.4605 30.3983 28.0403 34.8185 28.0403 40.2711ZM21.6936 69.5375C21.6936 67.4048 22.1131 64.9606 22.9282 62.9903C23.7433 61.02 24.9381 59.2297 26.4442 57.7217C27.9503 56.2137 29.7384 55.0175 31.7062 54.2014C33.6741 53.3853 35.7832 52.9652 37.9132 52.9652C40.0432 52.9652 42.1524 53.3853 44.1202 54.2014C46.0881 55.0175 47.8761 56.2137 49.3822 57.7217C50.8884 59.2297 52.0831 61.02 52.8982 62.9903C53.7133 64.9606 54.1329 67.4048 54.1329 69.5375C54.1329 69.5375 47.4334 74.4739 37.9132 74.4739C28.393 74.4739 21.6936 69.5375 21.6936 69.5375Z",
    fill: "url(#paint0_linear_79_1878)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_79_1878)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.87283,
    cy: 9.87283,
    r: 9.87283,
    transform: "matrix(-1 0 0 1 47.7871 30.3979)",
    fill: "url(#paint1_linear_79_1878)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.87283,
    cy: 9.87283,
    r: 9.37283,
    transform: "matrix(-1 0 0 1 47.7871 30.3979)",
    stroke: "#AAECD8",
    strokeOpacity: 0.76
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5718 69.3682C21.5718 67.2221 21.9945 65.097 22.8157 63.1142C23.637 61.1315 24.8408 59.3299 26.3583 57.8124C27.8758 56.2949 29.6774 55.0911 31.6601 54.2699C33.6429 53.4486 35.768 53.0259 37.9141 53.0259C40.0602 53.0259 42.1852 53.4486 44.168 54.2699C46.1507 55.0911 47.9523 56.2949 49.4698 57.8124C50.9873 59.3299 52.1911 61.1315 53.0124 63.1142C53.8336 65.097 54.2563 67.2221 54.2563 69.3682",
    stroke: "#AAECD8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_79_1878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8157 63.1142C21.9945 65.097 21.5718 67.2221 21.5718 69.3682C21.5718 69.3682 31.1604 75.0251 37.9141 75.0251C44.6677 75.0251 54.2563 69.3682 54.2563 69.3682C54.2563 67.2221 53.8336 65.097 53.0124 63.1142C52.1911 61.1315 50.9873 59.3299 49.4698 57.8124C47.9523 56.2949 46.1507 55.0911 44.168 54.2699C42.1852 53.4486 40.0602 53.0259 37.9141 53.0259C35.768 53.0259 33.6429 53.4486 31.6601 54.2699C29.6774 55.0911 27.8758 56.2949 26.3583 57.8124C24.8408 59.3299 23.637 61.1315 22.8157 63.1142Z",
    fill: "url(#paint2_linear_79_1878)",
    fillOpacity: 0.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9133,
    cy: 45.9133,
    r: 28.4133,
    stroke: "#302F3A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_1878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2998 39.5327C77.8099 42.5946 72.0641 42.864 71.8209 42.8723C71.7566 42.8749 71.6927 42.8616 71.6348 42.8334C71.577 42.8052 71.527 42.7632 71.4894 42.711C71.3458 42.5145 68.0118 37.8271 69.5017 34.7652C69.8523 34.0466 70.4737 33.4964 71.2295 33.2354C71.9853 32.9743 72.8138 33.0238 73.5332 33.3728C74.4365 33.8123 75.0383 34.5855 75.2118 35.482C76.0243 35.0653 77.0041 35.0616 77.9074 35.5012C78.626 35.8518 79.1762 36.4732 79.4372 37.229C79.6983 37.9848 79.6488 38.8133 79.2998 39.5327Z",
    fill: "#84B6A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_79_1878",
    x: -51.9586,
    y: -49.6021,
    width: 179.746,
    height: 179.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_79_1878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_79_1878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_79_1878",
    x: -58.4282,
    y: -26.9741,
    width: 192.685,
    height: 181.999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_79_1878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_79_1878",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1878",
    x1: 9,
    y1: 17,
    x2: 77.0064,
    y2: 57.9002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_1878",
    x1: 9.87283,
    y1: 0.987283,
    x2: 9.87283,
    y2: 19.7457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_1878",
    x1: 37.9141,
    y1: 54.1258,
    x2: 37.9141,
    y2: 75.0251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4531,
    height: 12.4531,
    fill: "white",
    transform: "translate(70.8021 30.3125) rotate(25.9463)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendly);
export default __webpack_public_path__ + "static/media/Friendly.4a1901c874d20860603c61eb12c64298.svg";
export { ForwardRef as ReactComponent };